export default [
  { path: '/main/analysis', name: 'MainAnalysis', component: () => import(/* webpackChunkName: "main-analysis" */ './index.vue') }
]
